<div *ngIf="isEnable" [ngClass]="(loaderClass) ? loaderClass : 'loader'">
    <svg [ngClass]="(svgCircleClass) ? svgCircleClass : 'svgCircle'">
      <circle 
      [ngClass]="(svgCirclePathClass) ? svgCirclePathClass : 'svgCirclePath'" 
      [attr.cx]="cx" 
      [attr.cy]="cy" 
      [attr.r]="r" fill="none" 
      [attr.stroke-width]="strokeWidth" 
      [attr.stroke-miterlimit]="strokeMiterlimit"/>
    </svg>
  </div>